import React, { useState, useMemo, useCallback } from "react";
import UserVideoModal from "../../../pages/user/courses/UserVideoModal";
import UserPDFReaderModal from "../../../pages/user/courses/UserPDFReaderModal";
import CommonTable from "../table/Table";
import { jwtDecode } from "jwt-decode";
import { markContentAsCompleted } from "../../../service/UserCourseService";
import { showErrorMessage, showSuccessMessage } from "../../global/Message/Message";
import { getCourseContentColumns } from "../../../assets/constants/courseContentColumn";
import usePagination from "../../../assets/hooks/PaginationHooks/usePagination";

const UserCourseContentTable = ({ tableConfig }) => {
  const {
    entries,
    courseId,
    onProgressUpdate,
    loadCourseContent,
    setShowContent,
    setSelectedRecord,
    pagination,
    onChange,
  } = tableConfig;
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState("");
  const [currentContentId, setCurrentContentId] = useState(null);
  const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
  const [currentPDFUrl, setCurrentPDFUrl] = useState("");

  const handleMarkDone = useCallback(async (record) => {
    try {
      const userId =
        jwtDecode(localStorage.getItem("authtoken"))?.userId ||
        localStorage.getItem("userId");
      const data = await markContentAsCompleted(courseId, record.contentId, userId);
      if (data.acknowledged) {
        showSuccessMessage(data.message);
        loadCourseContent();
      } else {
        showErrorMessage(data.message || "Failed to mark content as completed");
      }
    } catch (error) {
      console.error("Error marking content as done:", error);
      showErrorMessage("Something went wrong");
    }
  }, [courseId, loadCourseContent]);

  const handleCloseVideoModal = useCallback(() => {
    setCurrentVideoUrl("");
    setCurrentContentId(null);
    setIsVideoModalOpen(false);
    setTimeout(() => onProgressUpdate?.(), 500);
  }, [onProgressUpdate]);

  const handleClosePDFModal = useCallback(() => {
    setCurrentPDFUrl("");
    setCurrentContentId(null);
    setIsPDFModalOpen(false);
    setTimeout(() => onProgressUpdate?.(), 500);
  }, [onProgressUpdate]);

  const columns = useMemo(() => getCourseContentColumns({
    setSelectedRecord,
    setShowContent,
    onMarkDone: handleMarkDone,
  }), [setSelectedRecord, setShowContent, handleMarkDone]);

  return (
    <div>
      <UserVideoModal
        isOpen={isVideoModalOpen}
        fileName={currentVideoUrl}
        contentId={currentContentId}
        courseId={courseId}
        onClose={handleCloseVideoModal}
        isAcknowledged={entries.find(e => e.contentId === currentContentId)?.acknowledged || false}
      />
      <UserPDFReaderModal
        isOpen={isPDFModalOpen}
        fileName={currentPDFUrl}
        contentId={currentContentId}
        courseId={courseId}
        onClose={handleClosePDFModal}
        blockTime={10}
        isAcknowledged={entries.find(e => e.contentId === currentContentId)?.acknowledged || false}
      />
      <CommonTable
        data={entries}
        scroll={{ y: "48vh" }}
        className="hide-scrollbar top-table-radius"
        columns={columns}
        showLoader={false}
        pagination={pagination}
        onChange={onChange}
        serverSide={true}
        rowKey={(record) => record.contentId || record.id}
      />
    </div>
  );
};

export default UserCourseContentTable;
